import React from 'react';
import cn from 'classnames';
import styles from '../CreateNewWorkScheduleByPeriod.module.scss';

export const SectionHeader = ({ title, actions, className }) => (
  <div className={cn(styles.blockHeader, className)}>
    <h2 className={styles.blockTitle}>{title}</h2>
    {actions}
  </div>
);

export const FormSection = ({ title, actions, children, headerClassName }) => (
  <section className={styles.block}>
    <SectionHeader
      title={title}
      actions={actions}
      className={headerClassName}
    />
    {children}
  </section>
);
